import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// FastAPI 422 returns an array of {msg} — never render raw objects.
export const apiError = (e, fallback = "Something went wrong.") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") {
    if (d === "not_authenticated") return "Your session has expired. Please sign in again.";
    if (d === "forbidden") return "Your role does not have permission for this action.";
    if (d === "too_many_attempts") return "Too many attempts. Please wait a few minutes.";
    if (d === "invalid_credentials") return "Incorrect email or password.";
    if (d === "slug_exists") return "That slug is already in use.";
    if (d === "email_exists") return "A user with that email already exists.";
    if (d.startsWith("in_use:")) return `This image is currently used by: ${d.slice(7)}. Replace it there first.`;
    return d;
  }
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || fallback;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
  });
};
